export class AlertSettings{
  public static SUCCESS = "success";
  public static ERROR = "error";
  public static INFO = "info";
  public static WARNING = "warning";
}
